module.exports = __webpack_public_path__ + "img/step-2.4e0f3d9d.jpg";